import { PpHttpMethod, PpHttpOptions } from '@penpencil/common';

export const FILE_UPLOAD_API_OLD: PpHttpOptions = {
    apiPath: 'v1/admin/files',
    method: PpHttpMethod.POST,
};

export const FILE_UPLOAD_API: PpHttpOptions = {
    apiPath: 'v3/admin/files/s3-signed-url',
    method: PpHttpMethod.GET,
};

export const FILE_UPLOAD_API_JW_PLAYER: PpHttpOptions = {
    apiPath: 'v1/admin/files/jw-player',
    method: PpHttpMethod.POST,
};

export const FILE_UPLOAD_API_VIMEO: PpHttpOptions = {
    apiPath: 'v1/admin/files/vimeo/upload',
    method: PpHttpMethod.POST,
};

export const FILE_UPLOAD_API_CREATE_FILE: PpHttpOptions = {
    apiPath: 'v1/admin/files/create-file',
    method: PpHttpMethod.POST,
};

export const FILE_UPLOAD_API_DELETE = (fileId: string): PpHttpOptions => {
    return {
        apiPath: `v1/admin/files/${fileId}`,
        method: PpHttpMethod.DELETE,
    };
};

export const FILE_UPLOAD_API_SIGNED_COOKIE: PpHttpOptions = {
    apiPath: 'v1/admin/files/get-signed-cookie',
    method: PpHttpMethod.POST,
};

export const FILE_UPLOAD_API_AUDIO: PpHttpOptions = {
    apiPath: 'v1/admin/files/base64-to-audio',
    method: PpHttpMethod.POST,
};
